import { render, staticRenderFns } from "./PageNotfound.vue?vue&type=template&id=3ad40f8a&scoped=true&"
import script from "./PageNotfound.vue?vue&type=script&lang=js&"
export * from "./PageNotfound.vue?vue&type=script&lang=js&"
import style0 from "./PageNotfound.vue?vue&type=style&index=0&id=3ad40f8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad40f8a",
  null
  
)

export default component.exports